import { colors, typographyCss, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { useDropzone } from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';

type Props = {
  className?: string;
  mode: 'single-image' | 'multi-image';
  onDropAccepted: (files: File[]) => void;
};

const Root = styled.div<{ dragActive: boolean }>`
  ${typographyCss.Body3}
  align-items: center;
  border-radius: 8px;
  /* ignore-color */
  border: 2px dashed ${({ dragActive }) => (dragActive ? colors.wolt100 : cbSemanticCssVars.borderPrimary)};
  display: flex;
  justify-content: center;
  padding: 16px;
  color: ${cbSemanticCssVars.textPrimary};
  &:focus {
    border-color: ${colors.wolt100};
    outline: none;
  }
`;

const Content = styled.div``;

const PromptAction = styled(T.Body3).attrs({ fontWeight: 'semiBold' })`
  cursor: pointer;
  color: ${colors.wolt100};
`;

const Dropzone = ({ className, mode, onDropAccepted }: Props) => {
  const handleDropAccepted = async (files: File[]) => {
    if (!files.length) {
      return;
    }
    onDropAccepted(files);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
    },
    multiple: mode === 'multi-image',
    onDropAccepted: handleDropAccepted,
    useFsAccessApi: false,
  });

  return (
    <Root className={className} {...getRootProps()} dragActive={isDragActive}>
      <input {...getInputProps()} />
      <Content>
        <FormattedMessage
          id={mode === 'multi-image' ? 'image-upload.multiImage.prompt' : 'image-upload.chooseImagePrompt'}
          values={{ action: chunks => <PromptAction>{chunks}</PromptAction> }}
        />
        <br />
        <T.Small>
          <FormattedMessage id="image-upload.supportedFiles" />
        </T.Small>
      </Content>
    </Root>
  );
};

export default Dropzone;
